import { Tabs } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  get_order,
  open_orders,
  OrderAddComments
} from "../../actions/orders";
import close from "../../assets/cancel.svg";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";

// const { Step } = Steps;
const { TabPane } = Tabs;

const MyOrderWrap = (props) => {
  const history = useHistory();

  return (
    <div className="order-wrap">
      <div className="flex-between">
        <div className="left-sec">
          <label>{props.label}</label>
        </div>
        <div className="right-sec">
          <span
            className="close"
            onClick={() => {
              history.push("/open-orders");
            }}
          >
            <img src={close} alt="icon" width={18} />
          </span>
        </div>
      </div>
      {props.children}
    </div>
  );
};

const OpenOrderDetail = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const orders = useSelector(
    (state) => state?.orders?.open_orders?.data?.open_product_orders
  );
  const orders_count = useSelector(
    (state) => state?.orders?.open_orders?.data?.pagination?.total_count
  )
  const orders_loading = useSelector(
    (state) => state?.orders?.open_orders?.loading
  );
  const [order] = useState(location?.state?.prod);
  const order_comment = useSelector(
    (state) => state?.orders?.order_add_comments
  );
  const [tab, setTab] = useState("1");
  // const [comment, setComment] = useState("");

  useEffect(() => {
    if (location.state && location.state.sku) {
      dispatch(
        open_orders({
          email: localStorage.getItem("email"),
          sku: location.state?.sku,
        })
      );
    }
    // eslint-disable-next-line
  }, [location.state]);

  useEffect(() => {
    if (order_comment?.success) {
      toast.success("Commented Successfully.");
      // setComment("");
      dispatch(
        get_order({
          email: localStorage.getItem("email"),
          orderId: location.state?.order_id,
        })
      );
      dispatch({
        type: OrderAddComments.RESET,
      });
    }

    if (
      order_comment?.data?.status === false ||
      order_comment?.success === false
    ) {
      toast.error("Failed to add Comment.");
      dispatch({
        type: OrderAddComments.RESET,
      });
    }
    // eslint-disable-next-line
  }, [order_comment]);

  const order_status = {
    Confirmed: "success-text",
    Accepted: "success-text",
    "Awaiting signature": "warn-text",
  };

  const columns = [
    {
      header: "Date",
      accessor: "SoDate",
      width: 15,
      cell: (row) => (
        <span>{row.SoDate ? moment(row.SoDate, "YYYYMMDD").format("DD/MM/YYYY") : "-"}</span>
      ),
    },
    // {
    //   header: "Order Number",
    //   accessor: "order_number",
    //   width: 15,
    // },
    {
      header: "Sales order",
      accessor: "SoNumber",
      width: 15,
    },
    {
      header: "Customer PO",
      accessor: "Bstnk",
      width: 15,
    },
    {
      header: "Quantity Ordered",
      accessor: "Kwmeng",
      width: 15,
      cell: (row) => (
        <span>{row.Kwmeng ? parseInt(row.Kwmeng) : "-"}</span>
      ),
    },
    {
      header: "Delivered Quantity",
      accessor: "Deliveredqty",
      width: 15,
      cell: (row) => (
        <span>{row.Deliveredqty ? parseInt(row.Deliveredqty) : "-"}</span>
      ),
    },

    {
      header: "Pending",
      accessor: "Pendingqty",
      width: 15,
      cell: (row) => (
        <span>{row.Pendingqty ? parseInt(row.Pendingqty) : "-"}</span>
      ),
    },
  ];

  return (
    <NavWrap>
      <div className="card2 prod">
        <MyOrderWrap label={"Open Orders"}>
          <div className="details">
            <div className="flex-between">
              <div>
                <span className={`status ${order_status[order?.order_status]}`}>
                  {order?.order_status}
                </span>
              </div>
            </div>
            <div>
              <span className="nm large">{order?.brand}</span>
            </div>
            <div>
              <span className="nm">SKU Number - {order?.sku}</span>
            </div>
            <div>
              <span className="nm">
                {"Characteristics: " + orders?.[0]?.Maktx}
              </span>
            </div>
            <div>
              <span className="nm">
                Size Type : {order?.size} <br />
              </span>
            </div>
          </div>
          <div className="tabs mt1">
            <Tabs
              defaultActiveKey={"1"}
              onTabClick={(val) => {
                setTab(val);
              }}
            >
              <TabPane active={tab} tab="Order Details" key="2">
                <TableWrap total_count={orders_count}
                  perPageLimit={10}
                  isSearch={true}
                // onPageChange={(page) => {
                //   let obj = {
                //     email: localStorage.getItem("email"),
                //     authentication_token: localStorage.getItem("token"),
                //   };
                //   dispatch(open_orders({ ...obj, page: page, limit: 10 }));
                // }}
                >
                  <Table columns={columns} data={orders} action={false} loading={orders_loading} />
                </TableWrap>
              </TabPane>
            </Tabs>
          </div>
          {/* <div className="d-flex gap2 mt1">
            <div className="w50">
              <div className="tabs">
                <Tabs defaultActiveKey="1">
                  <TabPane tab="Comments">
                    <div className="comments">
                      <Steps size="small" direction="vertical">
                        {order?.comments?.map((ele) => {
                          return (
                            <Step
                              title={
                                <div className="comments">
                                  {ele?.content}
                                  <br />
                                  <span>By: {ele?.created_by}</span>
                                  <span>On: {ele?.date}</span>
                                </div>
                              }
                              icon={<img src={message} alt="message" />}
                            />
                          );
                        })}
                      </Steps>
                      <div className="comment-wrap">
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            dispatch(
                              order_add_comments({
                                order_id: location.state?.order_id,
                                comment,
                              })
                            );
                          }}
                        >
                          <input
                            placeholder="Enter Text"
                            name="comment"
                            value={comment}
                            onChange={(e) => {
                              setComment(e.target.value);
                            }}
                          />
                          <button
                            className="green-btn"
                            disabled={order_comment?.loading}
                          >
                            Submit
                          </button>
                        </form>
                      </div>
                    </div>
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </div> */}
        </MyOrderWrap>
      </div>
    </NavWrap>
  );
};

export default OpenOrderDetail;
